import React, { useState, useEffect } from 'react';
import {
  Box,
  Input,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  Td,
  Tag,
  Flex,
  Heading,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  FormControl,
  FormLabel,
} from '@chakra-ui/react';
import axios from 'axios';
const ticketToken = localStorage.getItem('ticketToken');
console.log("ticketToken",ticketToken);

const CertificatePool = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [newName, setNewName] = useState('');
  const [newId, setNewId] = useState('');
  const [newDescription, setNewDescription] = useState('');
  const [data, setData] = useState([]);
  const [selectedCertificate, setSelectedCertificate] = useState(null);
  

  const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    
    fetchCertificates();
  }, []);

  const fetchCertificates = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    console.log("ticketToken",ticketToken);
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/get-certificates`,
        {
            headers: {
                Authorization: `Bearer ${ticketToken}`
            }
        }
    );
      setData(response.data.data);
    } catch (error) {
      console.error('Error fetching certificates:', error);
    }
  };

  const handleAdd = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      const newCertificate = { name: newName, certificateId: newId, description: newDescription };
      await axios.post(`${process.env.REACT_APP_SERVER_URL}/admin/add-certificate`, newCertificate,{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      fetchCertificates();
      setNewName('');
      setNewId('');
      setNewDescription('');
      onClose();
    } catch (error) {
      console.error('Error adding certificate:', error);
    }
  };

  const handleUpdate = async () => {
    const ticketToken = sessionStorage.getItem('ticketToken');
    try {
      await axios.put(`${process.env.REACT_APP_SERVER_URL}/admin/update-certificate/${selectedCertificate._id}`, selectedCertificate,{
        headers: {
            Authorization: `Bearer ${ticketToken}`
        }
      });
      fetchCertificates();
      onClose();
    } catch (error) {
      console.error('Error updating certificate:', error);
    }
  };

  const handleEdit = (certificate) => {
    setSelectedCertificate(certificate);
    onOpen();
  };

  const filteredData = data.filter(item =>
    item.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  return (
    <Box p={4}>
      <Flex justifyContent="space-between" alignItems="center" mb={4}>
        <Heading>Certificates Pool</Heading>
        <Button colorScheme="teal" onClick={onOpen}  position="absolute" top="10px" right="10px" zIndex="1000">
          Add
        </Button>
      </Flex>

      <Input
        placeholder="Search..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
        mb={4}
      />

      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>ID</Th>
            <Th>Description</Th>
            <Th>Actions</Th>
          </Tr>
        </Thead>
        <Tbody>
          {filteredData.map((item, index) => (
            <Tr key={index}>
              <Td>
                <Tag>{item.name}</Tag>
              </Td>
              <Td>{item.certificateId}</Td>
              <Td>{item.description}</Td>
              <Td>
                <Button size="sm" colorScheme="blue" onClick={() => handleEdit(item)}>
                  Edit
                </Button>
              </Td>
            </Tr>
          ))}
        </Tbody>
      </Table>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{selectedCertificate ? 'Edit Certificate' : 'Add New Certificate'}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl>
              <FormLabel>Name</FormLabel>
              <Input
                placeholder="Name"
                value={selectedCertificate ? selectedCertificate.name : newName}
                onChange={(e) => selectedCertificate ? setSelectedCertificate({ ...selectedCertificate, name: e.target.value }) : setNewName(e.target.value)}
                mb={2}
              />
            </FormControl>
            <FormControl>
              <FormLabel>ID</FormLabel>
              <Input
                placeholder="ID"
                value={selectedCertificate ? selectedCertificate.certificateId : newId}
                onChange={(e) => selectedCertificate ? setSelectedCertificate({ ...selectedCertificate, certificateId: e.target.value }) : setNewId(e.target.value)}
                mb={2}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Description</FormLabel>
              <Input
                placeholder="Description"
                value={selectedCertificate ? selectedCertificate.description : newDescription}
                onChange={(e) => selectedCertificate ? setSelectedCertificate({ ...selectedCertificate, description: e.target.value }) : setNewDescription(e.target.value)}
                mb={2}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={selectedCertificate ? handleUpdate : handleAdd}>
              {selectedCertificate ? 'Update' : 'Submit'}
            </Button>
            <Button variant="ghost" onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default CertificatePool;